(function () {
  if (window.__cartCrossSellRegistered) return;
  window.__cartCrossSellRegistered = true;

  class CartCrossSell extends HTMLElement {
    connectedCallback() {
      var self = this;
      setTimeout(function () {
        try { self.init(); }
        catch (e) { console.error('[cart-cross-sell] init error:', e); }
      }, 0);

      // El morph del drawer puede reutilizar este elemento sin volver a
      // disparar connectedCallback: observamos cambios de hijos para
      // re-inicializar cuando el servidor reemplace las cards.
      this._observer = new MutationObserver(function () {
        if (self._reinitPending) return;
        self._reinitPending = true;
        window.setTimeout(function () {
          self._reinitPending = false;
          try { self.init(); }
          catch (e) { console.error('[cart-cross-sell] reinit error:', e); }
        }, 50);
      });
      this._observer.observe(this, { childList: true, subtree: true });

      // Rotar solo cuando el carrusel es visible (el drawer cerrado no
      // debe mantener un setInterval vivo tocando el layout).
      this._visible = false;
      this._intersection = new IntersectionObserver(function (entries) {
        self._visible = entries[0] ? entries[0].isIntersecting : false;
        if (self._visible) {
          self._restartRotation();
        } else {
          self._stopRotation();
        }
      });
      this._intersection.observe(this);
    }

    disconnectedCallback() {
      this._stopRotation();
      if (this._observer) { this._observer.disconnect(); this._observer = null; }
      if (this._intersection) { this._intersection.disconnect(); this._intersection = null; }
    }

    init() {
      this._stopRotation();

      var dotsContainer = this.querySelector('.cart-cross-sell__dots');
      var viewport = this.querySelector('.cart-cross-sell__viewport');
      if (!dotsContainer || !viewport) return;

      this.viewport = viewport;

      var visibleCount = parseInt(this.dataset.visibleCount || '5', 10);
      this.rotationMs = parseInt(this.dataset.rotationMs || '6000', 10);

      var allCards = Array.prototype.slice.call(viewport.children).filter(function (el) {
        return el.classList && el.classList.contains('cart-cross-sell__card');
      });

      if (allCards.length === 0) { this.style.display = 'none'; return; }

      // Shuffle
      for (var i = allCards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = allCards[i]; allCards[i] = allCards[j]; allCards[j] = tmp;
      }

      var picked = allCards.slice(0, Math.min(visibleCount, allCards.length));

      // Limpiar TODAS las cards del viewport (no solo picked)
      this._clearAllActive();
      picked[0].classList.add('is-active');

      // Dots: pintados por Liquid, solo añadir listeners
      var self = this;
      var dots = Array.prototype.slice.call(dotsContainer.querySelectorAll('.cart-cross-sell__dot'));
      dots.forEach(function (dot, idx) {
        if (dot.dataset.ccsBound === 'true') return;
        dot.dataset.ccsBound = 'true';
        dot.addEventListener('click', function () {
          self.goTo(idx);
          self._restartRotation();
        });
      });

      // Card listeners
      picked.forEach(function (card) {
        if (card.dataset.ccsBound === 'true') return;
        card.dataset.ccsBound = 'true';
        card.addEventListener('click', function (e) {
          e.preventDefault();
          self._addToCart(card);
        });
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            self._addToCart(card);
          }
        });
      });

      this.picked = picked;
      this.dots = dots;
      this.currentIndex = 0;
      this.totalSlides = picked.length;

      if (this.totalSlides > 1) this._startRotation();
    }

    // Limpia is-active de TODAS las cards del viewport, no solo de picked.
    // Es la única forma segura de eliminar el is-active que el HTML del
    // servidor mete en la primera card como fallback de Liquid.
    _clearAllActive() {
      if (!this.viewport) return;
      var all = this.viewport.querySelectorAll('.cart-cross-sell__card.is-active');
      for (var i = 0; i < all.length; i++) {
        all[i].classList.remove('is-active');
      }
    }

    goTo(index) {
      var picked = this.picked || [];
      var dots = this.dots || [];
      if (picked.length === 0) return;

      // IMPORTANTE: limpiar TODAS las cards, no solo picked.
      // Si el HTML del servidor metió is-active en una card que no está
      // en picked[], picked.forEach(remove) la dejaría visible.
      this._clearAllActive();
      if (picked[index]) picked[index].classList.add('is-active');

      dots.forEach(function (dot, k) {
        dot.classList.toggle('is-active', k === index);
        dot.setAttribute('aria-selected', k === index ? 'true' : 'false');
      });

      this.currentIndex = index;
    }

    _startRotation() {
      this._stopRotation();
      if (this._visible === false) return;
      var self = this;
      this.timer = window.setInterval(function () {
        self.goTo((self.currentIndex + 1) % self.totalSlides);
      }, this.rotationMs);
    }

    _stopRotation() {
      if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
    }

    _restartRotation() {
      if (this.totalSlides > 1) this._startRotation();
    }

    _addToCart(card) {
      if (card.classList.contains('is-loading')) return;
      var variantId = card.dataset.variantId;
      if (!variantId) return;

      this._stopRotation();
      card.classList.add('is-loading');

      var self = this;

      var routes = (window.Theme && window.Theme.routes) || {};
      fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return fetch((routes.cart_url || '/cart') + '.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          card.classList.remove('is-loading');
          self._restartRotation();
          // Sin "source": cart-icon interpreta itemCount como total absoluto.
          // (Con source 'product-form-component' lo sumaría como delta y
          // el contador del carrito quedaría inflado.)
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                itemCount: cart.item_count
              }
            }
          }));
        })
        .catch(function (err) {
          console.error('[cart-cross-sell] error añadiendo al carrito', err);
          card.classList.remove('is-loading');
          self._restartRotation();
        });
    }
  }

  if (!customElements.get('cart-cross-sell')) {
    customElements.define('cart-cross-sell', CartCrossSell);
  }

  // La re-inicialización tras los refrescos del drawer la cubre el
  // MutationObserver de cada instancia (connectedCallback); no hace falta
  // un listener global de cart:update duplicando el trabajo.
})();